var exports = {
  "iE": "xaee3c4fa--6ddd83--wrapper",
  "jK": "xaee3c4fa--6ddd83--modal-button-wrapper",
  "A1": "xaee3c4fa--6ddd83--_active",
  "Qj": "xaee3c4fa--6ddd83--ordering-button",
  "Y8": "xaee3c4fa--6ddd83--modal-content",
  "WY": "xaee3c4fa--6ddd83--modal-ordering-button",
};

module.exports = exports;
